import React, { useMemo } from 'react'
import { rem } from 'polished'
import styled from 'styled-components'
import Group from 'components/utils/Group'
import Heading from 'components/Luxkit/Typography/Heading'
import AccommodationRoomDetailsList from 'components/AccommodationKit/AccommodationRoomDetailsList'
import AccommodationAmenitiesList, { extractBedbankRoomPackageAmenityGroups } from 'components/AccommodationKit/AccommodationAmenitiesList'

const AboutRoomContainer = styled(Group)`
  padding: ${rem(20)};
`

interface Props {
  packageView: App.BedbankOfferPackageView;
}

function BedbankAboutRoomModalTab(props: Props) {
  const { packageView } = props

  const amenityGroups = useMemo(() => extractBedbankRoomPackageAmenityGroups(packageView.package), [packageView.package])

  return (
    <AboutRoomContainer direction="vertical" gap={32}>
      <Group direction="vertical" gap={20}>
        <AccommodationRoomDetailsList roomPackage={packageView.package} />
        {!!amenityGroups.length && <Group direction="vertical" gap={12}>
          <Heading variant="heading4">Room Amenities</Heading>
          <AccommodationAmenitiesList amenities={amenityGroups} />
        </Group>}
      </Group>
    </AboutRoomContainer>
  )
}

export default BedbankAboutRoomModalTab
